import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=488ec7f4&scoped=true&"
import script from "./MaterialForm.vue?vue&type=script&lang=js&"
export * from "./MaterialForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialForm.vue?vue&type=style&index=0&id=488ec7f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ec7f4",
  null
  
)

export default component.exports